import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";
import Header from "./Component/Header.jsx";
import Home from "./Component/Home.jsx";
import Login from "./Component/Login.jsx";
import Journey from "./Component/StartJourney.jsx";
import { ToastContainer } from "react-toastify";
import ToastHandler from "./Component/ToastHandler.jsx";
import "react-toastify/dist/ReactToastify.css";
import People from "./Component/People.jsx";
import Cards from "./Component/Cards.jsx";
import Services from "./Component/Services.jsx";
import PeopleCard from "./Component/PeopleCard.jsx";
import PeopleManage from "./Component/PeopleManage.jsx";
import NonTechnicalStaff from "./Component/NonTechnicalStaff.jsx";
import EditAddModal from "./Component/EditAddModal.jsx";
import Footer from "./Component/Footer.jsx";
import { Link, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import ProfilePage from "./Component/Profilepage.jsx";
import Network from "./Component/Network.jsx";
import EditProfilePage from "./Component/EditProfilepage.jsx";
import Card from "./Component/Cards.jsx";
import CardEdit from "./Component/CardEdit.jsx";
import RoutesPage from "./Component/RoutesPages.jsx";
import RoutesPage2 from "./Component/RoutesPages2.jsx";
import { Base_Url } from "./config";
import CscUploads from "./Component/CscUploads.jsx";
import Page404 from "./Component/Page404.jsx";
import ExFaculty from "./Component/ExFaculty.jsx";
import EditScientific from "./Component/EditScientific.jsx";
import NewsAndAnnouncement from "./Component/NewsAndAnnouncement.jsx";
import EditNewsAndAnnouncement from "./Component/EditNewsAndAnnouncement.jsx";
import ExStaff from "./Component/ExStaff.jsx";
import AddRoutes from "./Component/AddRoutes.jsx";
import EditCard from "./Component/EditCard.jsx";
import AddPages from "./Component/AddPages.jsx";
import AddCardRoutes from "./Component/AddCardRoutes.jsx";
import ManageJodit from "./Component/ManageJodit.jsx";
import ManageUsers from "./Component/ManageUsers.jsx";
import AddCardTitle from "./Component/AddCardTitle.jsx";
import AddHowto from "./Component/AddHowto.jsx";
import AllNews from "./Component/AllNews.jsx";
import CrudJourney from "./Component/CrudJourney.jsx";
import EditHowTo from "./Component/EditHowto.jsx";
import EditCardTitle from "./Component/EditCardTitle.jsx";
import EditRoutesPage from "./Component/EditRoutesPage.jsx";
import ShowHowto from "./Component/Showhowto.jsx";
import PeopleProfile from "./Component/PeopleProfile.jsx";
import EditPeople from "./Component/EditPeople.jsx";
import Staff from "./Component/Staff.jsx";
import ShowScientific from "./Component/ShowScientific.jsx";
import EditContactInfo from "./Component/EditContactInfo.jsx";
import AddContact from "./Component/AddContact.jsx";
import Contact from "./Component/Contact.jsx";
import Scientific from "./Component/Scientific.jsx";
import axios from "axios";
import { Bell, Computer, Settings2, User } from "lucide-react";
import EditRoutes from "./Component/EditRoutes.jsx";
import { FaEdit, FaPlus, FaPlusCircle, FaTrash } from "react-icons/fa";
import DynamicIcon from "./Component/DynamicIcons.jsx";
import ImageUpload from "./Component/ImageUpload.jsx";
import { setState } from "./redux/isStafforFaculty.js";
import { setStaffData } from "./redux/staffSlice.js";
import { setFacultyProfileData } from "./redux/facultySlice.js";
import Faculty from "./Component/FacultyPage.jsx";
import Os from "./Component/Os.jsx";
import ExHead from "./Component/ExHead.jsx";
import Ird from "./Component/Ird.jsx";
import ClientIP from "./Component/ClientIp.jsx";
import AdminContactManager from "./Component/AdminContactManager.jsx";
import JourneyView from "./Component/Journey.jsx";
import SearchCrud from "./Component/SearchCrud.jsx";

function App() {
  const [allRoutes, setAllRoutes] = useState([]);
  const [allCardsInfo, setAllCardsInfo] = useState([]);
  const [allCardsTitle, setAllCardsTitle] = useState([]);
  const [allPagesInfo, setAllPagesInfo] = useState([]);

  const userfromwebmaster = useSelector((state) => state.user);

  const webmaster = useSelector((state) => state.user);
  const facultstaff = useSelector((state) => state.facultyuser);
  const staffuser = useSelector((state) => state.staffuser);
  const statecsc = useSelector((state) => state.statecsc);

  // console.log(statecsc, "this is state");
  // console.log(webmaster, "this is webmaster");
  // console.log(facultstaff, "this is faculty");
  // console.log(staffuser, "this is staff");

  const hasCardEditPermission = (userId, userState) => {
    return (
      userState === 0 || // webmaster
      (userState === 1 &&
        facultstaff?.facultyprofileData?.user_id === userId) || // faculty
      (userState === 2 && staffuser?.staffData?.user_id === userId)
    ); // staff
  };

  const dispatch = useDispatch();
  const isCscMember = async () => {
    if (
      webmaster.userData !== "" &&
      webmaster.userData !== null &&
      webmaster.userData !== undefined
    ) {
      dispatch(setState({ userState: 0 }));
      // alert("User is a webmaster");
    } else if (
      facultstaff.facultyprofileData !== "" &&
      facultstaff.facultyprofileData !== null &&
      facultstaff.facultyprofileData !== undefined
    ) {
      dispatch(setState({ userState: 1 }));
      // alert("User is a faculty");
    } else if (
      staffuser.staffData !== "" &&
      staffuser.staffData !== null &&
      staffuser.staffData !== undefined
    ) {
      dispatch(setState({ userState: 2 }));
      // alert("User is a staff");
    } else {
      console.log("You are not a valid user");
    }
  };

  useEffect(() => {
    isCscMember();
  }, [webmaster.userData, facultstaff.facultyprofileData, staffuser.staffData]);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const response = await fetch(`${Base_Url}/createroutes`);
        if (!response.ok) {
          throw new Error("Failed to fetch pages");
        }
        const data = await response.json();
        setAllRoutes(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    };

    fetchRoutes();
  }, []);

  const fetchCardsContent = async () => {
    try {
      const response = await axios.get(`${Base_Url}/cardsinfo`);
      // console.log(response.data);
      setAllCardsInfo(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Failed to fetch routes", err);
      setAllCardsInfo([]);
    }
  };
  useEffect(() => {
    fetchCardsContent();
  }, []);
  useEffect(() => {
    const fetchCardsTitle = async () => {
      try {
        const response = await axios.get(`${Base_Url}/card-descriptions`);
        // console.log(response.data);
        setAllCardsTitle(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error("Failed to fetch routes", err);
        setAllCardsTitle([]);
      }
    };
    fetchCardsTitle();
  }, []);

  useEffect(() => {
    const fetchPagesContent = async () => {
      try {
        const response = await axios.get(`${Base_Url}/pages`);
        // console.log(response.data);
        setAllPagesInfo(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error("Failed to fetch routes", err);
        setAllPagesInfo([]);
      }
    };
    fetchPagesContent();
  }, []);

  // console.log(allPagesInfo);

  const hasEditPermissionPages = (cardAuthors, currentUser, statecsc) => {
    // If state is 0 (webmaster), allow editing for everyone
    // console.log(statecsc, "type of users");
    // console.log(cardAuthors, "pages author");
    // console.log(currentUser, "current user");
    if (statecsc == 0) return true;

    // If no authors specified or no current user, deny permission
    if (!cardAuthors || !currentUser) return false;

    // Split authors and trim whitespace
    const authorList = cardAuthors?.split(",").map((author) => author.trim());

    // Check if current user is in authors list
    return authorList.includes(currentUser);
  };
  const DynamicContent = ({ data }) => {
    // console.log(allPagesInfo);

    // console.log(data);
    // Check if 'data' is an array or an object
    const contentData = Array.isArray(data) ? data[0] : data;

    // Filter based on route_id if it's an array
    const filterPagebasedonparentid = Array.isArray(contentData)
      ? allPagesInfo.filter((item) => item.route_id == contentData.id)
      : allPagesInfo.filter((item) => item.route_id == contentData.id);

    // console.log(filterPagebasedonparentid, "pages data");

    const navigate = useNavigate();

    // dynmic pages
    return (
      <div className="container-fluid" style={{ minHeight: "55vh" }}>
        <div className="row p-0 mt-0 vw-100">
          <div className="col-12 p-0">
            <h3 className="highlights-heading text-center d-flex justify-content-center mt-5">
              {filterPagebasedonparentid[0]?.page_title || "Add Pages Content"}

              {filterPagebasedonparentid[0]?.page_title ? (
                <>
                  {hasEditPermissionPages(
                    filterPagebasedonparentid[0]?.author,
                    statecsc?.userState === 0
                      ? webmaster?.userData?.userid
                      : statecsc?.userState === 1
                      ? facultstaff?.facultyprofileData?.user_id
                      : staffuser?.staffData?.user_id,
                    statecsc?.userState
                  ) && (
                    <div>
                      <FaEdit
                        className="edit-page"
                        onClick={() => navigate(`/edit-page/${data.id}`)}
                      />
                    </div>
                  )}
                </>
              ) : (
                <FaPlusCircle
                  onClick={() => navigate(`/add-page/${data.id}`)}
                />
              )}
            </h3>
          </div>
          <div className="col-12 px-0">
            <div
              className="dynamic-content"
              dangerouslySetInnerHTML={{
                __html: filterPagebasedonparentid[0]?.page_details,
              }}
            />
          </div>
        </div>
        <style>
          {`
            .dynamic-content {
              width: 100%;
              padding: 0px 100px;
            }
               @media (max-width: 576px) {
    .dynamic-content {
              width: 100%;
              padding: 0px 2px 10px 20px;
            }
  }
            .dynamic-content * {
              max-width: 100%;
              margin-left: 0;
              margin-right: 0;
            }
            .dynamic-content img {
              max-width: 100%;
              height: auto;
            }
            .dynamic-content p, 
            .dynamic-content div, 
            .dynamic-content section {
              width: 100%;
            }
            .container-fluid {
              padding-left: 0;
              padding-right: 0;
            }
            .px-0 {
              padding-left: 0 !important;
              padding-right: 0 !important;
            }
          `}
        </style>
      </div>
    );
  };

  // console.log(allCardsInfo);

  const hasEditPermission = (cardAuthors, currentUser, statecsc) => {
    // If state is 0 (webmaster), allow editing for everyone
    // console.log(statecsc);
    // console.log(cardAuthors);
    if (statecsc == 0) return true;

    // If no authors specified or no current user, deny permission
    if (!cardAuthors || !currentUser) return false;

    // Split authors and trim whitespace
    const authorList = cardAuthors?.split(",").map((author) => author.trim());

    // Check if current user is in authors list
    return authorList.includes(currentUser);
  };
  // dynamic cards

  const CardsContent = ({ data }) => {
    // console.log(data);
    // console.log(allCardsInfo);

    let filtercardbasedonparentid = allCardsInfo.filter(
      (item) => item.route_id == data.id
    );
    // console.log(filtercardbasedonparentid);
    // console.log(allCardsTitle);

    let titleofcardpage =
      filtercardbasedonparentid.length > 0 &&
      filtercardbasedonparentid[0]?.route_id
        ? allCardsTitle.filter(
            (item) => item.route_id == filtercardbasedonparentid[0]?.route_id
          )
        : allCardsTitle.filter((item) => item.route_id == data.id);

    const navigate = useNavigate();

    // console.log(statecsc);

    const deletecards = async (pageId) => {
      if (!window.confirm("Are you sure you want to delete this card?")) return;

      try {
        await axios.delete(`${Base_Url}/cardsinfo/${pageId}`);
        alert("cardsinfo deleted successfully");
        fetchCardsContent();
      } catch (error) {
        console.error("Error deleting cardsinfo:", error);
        alert("Failed to delete cardsinfo");
      }
    };
    const iconStyles = "ms-5 cursor-pointer hover:opacity-80";

    // console.log(filtercardbasedonparentid, "filtercardbasedonparentid");
    return (
      <div className="container my-5">
        {/* <div>
          <h2 className="page-title">
            {titleofcardpage[0]?.title1
              ? (
                <>
                  {titleofcardpage[0]?.title1?.split(' ')?.slice(0, -1)?.join(' ')}
                  <span className="highlight-title" style={{ color: '#c21717' }}>
                    {titleofcardpage[0]?.title1?.split(' ')?.slice(-1)}
                  </span>
                </>
              )
              : "Add Card Description"
            }
            
            {titleofcardpage[0]?.title1 ? (
              <FaEdit
                className="ms-5"
                color="#c21717"
                onClick={() =>
                  navigate(
                    `/edit-cardtitle/${titleofcardpage[0]?.route_id || data?.id}`
                  )
                }
              />
            ) : (
              <FaPlus
                className="ms-5"
                color="#c21717"
                onClick={() =>
                  navigate(
                    `/add-cardtitle/${titleofcardpage[0]?.route_id || data?.id}`
                  )
                }
              />
            )}
          </h2>
          <p className="section-description text-center">
            {titleofcardpage[0]?.title2}
          </p>

          <h3 className="highlights-heading text-center d-flex justify-content-center">
            {titleofcardpage[0]?.title3 || "Add Card"}

            <FaPlus
              className='ms-5'
              color='#c21717'
              onClick={() => navigate(`/add-card/${titleofcardpage[0]?.route_id || data?.id}`)}
            />
          </h3>
        </div>
        
        
        */}

        <div>
          {/* Main Title Section */}
          <h2 className="page-title flex items-center">
            {titleofcardpage[0]?.title1 ||
            titleofcardpage[0]?.title2 ||
            titleofcardpage[0]?.title3 ? (
              <>
                {titleofcardpage[0]?.title1
                  ?.split(" ")
                  ?.slice(0, -1)
                  ?.join(" ")}
                <span className="highlight-title" style={{ color: "#c21717" }}>
                  {titleofcardpage[0]?.title1?.split(" ")?.slice(-1)}
                </span>
              </>
            ) : (
              ""
            )}
            {(userfromwebmaster.userExists || statecsc.userState === 0) &&
              (titleofcardpage[0]?.title1 ||
              titleofcardpage[0]?.title2 ||
              titleofcardpage[0]?.title3 ? (
                <FaEdit
                  className="ms-5"
                  color="#c21717"
                  onClick={() =>
                    navigate(
                      `/edit-cardtitle/${
                        titleofcardpage[0]?.route_id || data?.id
                      }`
                    )
                  }
                />
              ) : (
                <FaPlus
                  className="ms-5"
                  color="#c21717"
                  onClick={() =>
                    navigate(
                      `/add-cardtitle/${
                        titleofcardpage[0]?.route_id || data?.id
                      }`
                    )
                  }
                />
              ))}
          </h2>

          {/* Description Section */}
          <div className="flex items-center justify-center">
            <p className="section-description text-center">
              {titleofcardpage[0]?.title2}
            </p>
            {(userfromwebmaster.userExists || statecsc.userState === 0) &&
              (titleofcardpage[0]?.title1 ||
              titleofcardpage[0]?.title2 ||
              titleofcardpage[0]?.title3 ? (
                <FaEdit
                  className={iconStyles}
                  color="#c21717"
                  onClick={() =>
                    navigate(
                      `/edit-cardtitle/${
                        titleofcardpage[0]?.route_id || data?.id
                      }`
                    )
                  }
                />
              ) : (
                <FaPlus
                  className={iconStyles}
                  color="#c21717"
                  onClick={() =>
                    navigate(
                      `/add-cardtitle/${
                        titleofcardpage[0]?.route_id || data?.id
                      }`
                    )
                  }
                />
              ))}
          </div>

          {/* Highlights Heading Section */}
          <h3
            className={`highlights-headingnew text-center flex items-center justify-center ${
              titleofcardpage[0]?.title3 != "" ||
              titleofcardpage[0]?.title3 != null ||
              titleofcardpage[0]?.undefined != ""
                ? ""
                : "highlights-heading"
            }`}
          >
            <span className="text-center justify-content-center">
              {titleofcardpage[0]?.title3 || ""}
            </span>
            {userfromwebmaster.userExists || statecsc.userState === 0 ? (
              titleofcardpage[0]?.title3 ||
              titleofcardpage[0]?.title2 ||
              titleofcardpage[0]?.title1 ? (
                <>
                  <FaEdit
                    onClick={() =>
                      navigate(
                        `/edit-cardtitle/${
                          titleofcardpage[0]?.route_id || data?.id
                        }`
                      )
                    }
                  />
                  <FaPlus
                    className={iconStyles}
                    color="#c21717"
                    onClick={() =>
                      navigate(
                        `/add-card/${titleofcardpage[0]?.route_id || data?.id}`
                      )
                    }
                  />
                </>
              ) : (
                ""
              )
            ) : null}
          </h3>
        </div>

        <div className="row g-4 mt-4 justify-content-center cardstop">
          {filtercardbasedonparentid?.map((item, index) => {
            const cardInfo = item.card_details;

            let author = item.author;
            let authorArray = author?.split(",");
            // console.log(authorArray);
            // console.log(cardInfo, "card  details");
            // console.log(item, "whole cards");

            return (
              // <div key={item.id} className="col-md-6 col-lg-3">
              //   <div className="service-card position-relative h-100">
              //     <div className="card-body d-flex flex-column position-relative h-100">
              //       {hasEditPermission(
              //         item.card_details.author,
              //         statecsc?.userState == 0
              //           ? webmaster?.userData?.userid
              //           : statecsc?.userState == 1
              //           ? facultstaff?.facultyprofileData?.user_id
              //           : staffuser?.staffData?.user_id,
              //         statecsc?.userState
              //       ) && (
              //         <div
              //           className="position-absolute"
              //           style={{ right: "10px", top: "10px" }}
              //         >
              //           <FaEdit
              //             className="edit-card"
              //             onClick={() => navigate(`/edit-card/${item.id}`)}
              //           />
              //           <FaTrash
              //             className="edit-card ms-2"
              //             onClick={() => deletecards(item.id)}
              //           />
              //         </div>
              //       )}

              //       <div className="content-wrapper">
              //         <div className="icon-wrapper">
              //           <DynamicIcon name={`${cardInfo.icon}`} size={34} />
              //         </div>

              //         <h5 className="card-title text-center" style={{textAlign:"center"}}>
              //           {cardInfo?.title.toUpperCase()}
              //         </h5>

              //         {/* <div className="card-text">
              //           {item?.card_desc ? (
              //             <div>{item?.card_desc}</div>
              //           ) : (
              //             <div>
              //               {cardInfo?.items.map((subItem, subIndex) => (
              //                 <Link
              //                   key={subIndex}
              //                   to={subItem.link}
              //                   className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              //                 >
              //                   {subItem.name}
              //                   <span className="badge bg-red-500 roundlink rounded-pill mt-2">
              //                     View
              //                   </span>
              //                 </Link>
              //               ))}
              //             </div>
              //           )}
              //         </div> */}
              //         <div className="card-text">
              //           {cardInfo?.card_desc ? (
              //             <div>{cardInfo?.card_desc}</div>
              //           ) : (
              //             <div>
              //               {cardInfo?.items &&
              //                 cardInfo.items.length > 0 &&
              //                 cardInfo.items.map((subItem, subIndex) => (
              //                   <Link
              //                     key={subIndex}
              //                     to={subItem.link}
              //                     className="list-group-item list-group-item-action text-center d-flex justify-content-center align-items-center"
              //                   >
              //                     {subItem.name}
              //                   </Link>
              //                 ))}
              //             </div>
              //           )}
              //         </div>
              //       </div>
              //       {cardInfo?.externalLink != "" ? (
              //         <div className="view-more-wrapper">
              //           <a
              //             href={`${cardInfo.externalLink}`}
              //             target="_blank"
              //             className="text-decoration-none d-flex justify-content-center"
              //           >
              //             <p className="btn-link text-center mb-0">
              //               View More...
              //             </p>
              //           </a>
              //         </div>
              //       ) : (
              //         <div className="view-more-wrapper">
              //           <Link
              //             to={`${cardInfo?.cardpath}`}
              //             className="text-decoration-none d-flex justify-content-center"
              //           >
              //             <p className="btn-link text-center mb-0">
              //               View More...
              //             </p>
              //           </Link>
              //         </div>
              //       )}
              //     </div>
              //   </div>
              // </div>

              <div key={item.id} className="col-md-6 col-lg-3">
                <div className="service-card position-relative h-100">
                  <div className="card-body d-flex flex-column position-relative h-100">
                    {hasEditPermission(
                      item.card_details.author,
                      statecsc?.userState == 0
                        ? webmaster?.userData?.userid
                        : statecsc?.userState == 1
                        ? facultstaff?.facultyprofileData?.user_id
                        : staffuser?.staffData?.user_id,
                      statecsc?.userState
                    ) && (
                      <div
                        className="position-absolute"
                        style={{ right: "10px", top: "10px" }}
                      >
                        <FaEdit
                          className="edit-card"
                          onClick={() => navigate(`/edit-card/${item.id}`)}
                        />
                        <FaTrash
                          className="edit-card ms-2"
                          onClick={() => deletecards(item.id)}
                        />
                      </div>
                    )}

                    <div className="content-wrapper">
                      {cardInfo?.externalLink != "" ? (
                        <a
                          href={`${cardInfo.externalLink}`}
                          target="_blank"
                          className="text-decoration-none"
                        >
                          <div className="icon-wrapper">
                            <DynamicIcon name={`${cardInfo.icon}`} size={34} />
                          </div>
                        </a>
                      ) : (
                        <Link
                          to={`${cardInfo?.cardpath}`}
                          className="text-decoration-none"
                        >
                          <div className="icon-wrapper">
                            <DynamicIcon name={`${cardInfo.icon}`} size={34} />
                          </div>
                        </Link>
                      )}

                      <h5
                        className="card-title text-center"
                        style={{ textAlign: "center" }}
                      >
                        {cardInfo?.title.toUpperCase()}
                      </h5>

                      <div className="card-text">
                        {cardInfo?.card_desc ? (
                          <div>{cardInfo?.card_desc}</div>
                        ) : (
                          <div>
                            {cardInfo?.items &&
                              cardInfo.items.length > 0 &&
                              cardInfo.items.map((subItem, subIndex) =>
                                cardInfo?.externalLink != "" ? (
                                  <a
                                    key={subIndex}
                                    href={cardInfo.externalLink}
                                    target="_blank"
                                    className="list-group-item list-group-item-action text-center d-flex justify-content-center align-items-center"
                                  >
                                    {subItem.name}
                                  </a>
                                ) : (
                                  <Link
                                    key={subIndex}
                                    to={`${cardInfo?.cardpath}`}
                                    className="list-group-item list-group-item-action text-center d-flex justify-content-center align-items-center"
                                  >
                                    {subItem.name}
                                  </Link>
                                )
                              )}
                          </div>
                        )}
                      </div>
                    </div>
                    {cardInfo?.externalLink != "" ? (
                      <div className="view-more-wrapper">
                        <a
                          href={`${cardInfo.externalLink}`}
                          target="_blank"
                          className="text-decoration-none d-flex justify-content-center"
                        >
                          <p className="btn-link text-center mb-0">
                            View More...
                          </p>
                        </a>
                      </div>
                    ) : (
                      <div className="view-more-wrapper">
                        <Link
                          to={`${cardInfo?.cardpath}`}
                          className="text-decoration-none d-flex justify-content-center"
                        >
                          <p className="btn-link text-center mb-0">
                            View More...
                          </p>
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div>
      <ToastHandler />
      <ToastContainer />
      <Header />
      <Routes>
        {/* Static Routes */}
        {/* <Route path="/uploadspdf" element={<ImageUpload />} /> */}
        {/* <Route path="/add-pages/:id" element={<AddPages />} /> */}
        {/* <Route path="/howto/:id" element={<ShowHowtoPage />} /> */}
        {/* <Route path="/add-card" element={<AddServiceCard />} /> */}
        {/* <Route path="/" element={<Home />} />
        <Route path="/handlenewsannouncement" element={<NewsAndAnnouncement />} />
        <Route path="/handlenewsannouncement/:id" element={<EditNewsAndAnnouncement />} />
        <Route path="/manage-csc-website" element={<Login />} />
        <Route path="/manage-users" element={<ManageUsers />} />
        <Route path="/getting-started" element={<Journey />} />
        <Route path="/people" element={<People />} />
        <Route path="/faculty" element={<Faculty />} />
        <Route path="/ex-faculty" element={<ExFaculty />} />
        <Route path="/uploads" element={ <CscUploads /> }  />
        <Route path="/ex-staff" element={<ExStaff />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/edit-people/:id" element={<EditPeople />} />
        <Route path="/add-people" element={<EditPeople />} />
        <Route path="/add-page/:id" element={<RoutesPage />} />
        <Route path="/edit-page/:id" element={<EditRoutesPage />} />
        <Route path="/peoplecard" element={<PeopleCard />} />
        <Route path="/contact" element={<Contact /> } />
        <Route path="/add-contact" element={<AddContact /> } />
        <Route path="/staticservices" element={<Services />} />
        <Route path="/howto" element={<ShowHowto />} />
        <Route path="/services/network" element={<Network />} />
        <Route path="/info/:id" element={<ProfilePage />} />
        <Route path="/people/:id" element={<PeopleProfile />} />
        <Route path="/editinfo/:id" element={<EditProfilePage />} />
        <Route path="/people-manage" element={<PeopleManage />} />
        <Route path="/add-profile" element={<EditAddModal />} />
        <Route path="/add-routes" element={<AddRoutes />} />
        <Route path="/edit-routes/:id" element={<EditRoutes />} />
        <Route path="/add-cardtitle/:id" element={<AddCardTitle />} />
        <Route path="/edit-cardtitle/:id" element={<EditCardTitle />} />
        <Route path="/add-card/:id" element={<AddCardRoutes />} />
        <Route path="/edit-contact/:id"  element={<EditContactInfo />} />
        <Route path="/add-howto" element={<AddHowto />} />
        <Route path="/edit-howto/:id" element={<EditHowTo />} />
        <Route path="/edit-card/:cardId" element={ <EditCard />} />
        <Route path="/cards" element={ <Card />} />
        <Route path="/cardedit/:id" element={ <CardEdit />} />
        <Route path="/edit-profile/:id"  element={  userfromwebmaster.userExists || statecsc.userState === 0  ? <EditAddModal /> : <Navigate to="/" />} />
        <Route path="*" element={<Page404 />} /> */}

        <Route path="/" element={<Home />} />
        <Route path="/allnewsandannouncement" element={<AllNews />} />
        <Route
          path="/services-software-scientific"
          element={<ShowScientific />}
        />
        {/* <Route path="/showscientific" element={<ShowScientific />} /> */}
        <Route
          path="/add-scisoft"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              // true ? (
              <Scientific />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/editscientific/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              // true ? (
              <EditScientific />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        {/* <Route path="/add-scisoft" element={<Scientific />} /> */}
        {/* <Route path="/editscientific/:id" element={<EditScientific />} /> */}
        <Route
          path="/handlenewsannouncement"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <NewsAndAnnouncement />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/handlenewsannouncement/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditNewsAndAnnouncement />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/manage-csc-website" element={<Login />} />
        <Route
          path="/manage-users"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <ManageUsers />
            ) : (
              <Navigate to="/" />
            )
          }
        />
          <Route
         path="/manage-journey" 
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <CrudJourney />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        {/* <Route path="/getting-started" element={<Journey />} /> */}
           <Route path="/getting-started" element={<JourneyView />} />
        <Route path="/people" element={<People />} />
        <Route path="/academic" element={<Faculty />} />
        <Route path="/ex-academic" element={<ExFaculty />} />
        <Route path="/former-heads" element={<ExHead />} />
         <Route path="/client-ip" element={<ClientIP />} />
        <Route
          path="/uploads"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <CscUploads />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/ex-non-academic" element={<ExStaff />} />
        <Route path="/techinal-staff" element={<Staff />} />
        <Route path="/non-techinal-staff" element={<NonTechnicalStaff />} />
        {/* <Route path="/ird" element={<Ird />} /> */}
        {/* <Route path="/os" element={<Os />} /> */}
  
 
          {/* <Route path="/manage-journey" element={<CrudJourney />} /> */}
        <Route
          path="/edit-people/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditPeople />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/add-people"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditPeople />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/add-page/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              // <RoutesPage />
              <RoutesPage2 />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/edit-page/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditRoutesPage />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/peoplecard" element={<PeopleCard />} />
        <Route path="/editor" element={<ManageJodit />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin-contact-manager"  element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <AdminContactManager />
            ) : (
              <Navigate to="/" />
            )
          }/>
        <Route
          path="/add-contact"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <AddContact />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/staticservices" element={<Services />} />
        <Route path="/howto" element={<ShowHowto />} />

        <Route path="/services/network" element={<Network />} />
        <Route path="/info/:id" element={<ProfilePage />} />
        <Route path="/people/:id" element={<PeopleProfile />} />
        <Route
          path="/editinfo/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditProfilePage />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/people-manage"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <PeopleManage />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/add-profile"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditAddModal />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/add-routes"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <AddRoutes />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/edit-routes/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditRoutes />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/add-cardtitle/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <AddCardTitle />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/edit-cardtitle/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditCardTitle />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        {/* <Route path="/add-card/:id" element={  userfromwebmaster.userExists || statecsc.userState === 0  ? <AddCardRoutes /> : <Navigate to="/" />} />
<Route path="/edit-card/:cardId" element={  userfromwebmaster.userExists || statecsc.userState === 0  ? <EditCard /> : <Navigate to="/" />} /> */}
        <Route
          path="/edit-card/:cardId"
          element={
            userfromwebmaster.userExists ||
            statecsc.userState === 0 ||
            hasCardEditPermission(
              statecsc?.userState === 1
                ? facultstaff?.facultyprofileData?.user_id
                : staffuser?.staffData?.user_id,
              statecsc?.userState
            ) ? (
              <EditCard />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route
          path="/add-card/:id"
          element={
            userfromwebmaster.userExists ||
            statecsc.userState === 0 ||
            hasCardEditPermission(
              statecsc?.userState === 1
                ? facultstaff?.facultyprofileData?.user_id
                : staffuser?.staffData?.user_id,
              statecsc?.userState
            ) ? (
              <AddCardRoutes />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/edit-contact/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditContactInfo />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/add-howto"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <AddHowto />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/edit-howto/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditHowTo />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="/cards" element={<Card />} />
        <Route
          path="/cardedit/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <CardEdit />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/edit-profile/:id"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <EditAddModal />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/manage-search"
          element={
            userfromwebmaster.userExists || statecsc.userState === 0 ? (
              <SearchCrud />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="*" element={<Page404 />} />        
        {/* <Route path="*" element={<Navigate to="/" />} /> */}

        {/* Dynamic Routes */}
        {allRoutes.map((route, index) => {
          if (route.iscard === 1) {
            return (
              <Route
                key={index}
                path={route.routes}
                element={<CardsContent data={route} />}
              />
            );
          } else if (route.ispage === 1) {
            return (
              <Route
                key={index}
                path={route.routes}
                element={<DynamicContent data={route} />}
              />
            );
          }
          return null;
        })}
      </Routes>
      <ToastContainer />
      <Footer />
    </div>
  );
}

export default App;
